export type TCategoryName =
    | 'music'
    | 'podcast'
    | 'voice-over'
    | 'sound-design'
    | 'cover'
    | 'beats'
    | 'audiobook'
    | 'recording'
    | 'other'

export type TCategory = {
    id: number
    title: string
    name: TCategoryName
}

export const CATEGORIES: TCategory[] = [
    { id: 4, title: 'Music', name: 'music' },
    { id: 7, title: 'Podcast', name: 'podcast' },
    { id: 10, title: 'Voice Over', name: 'voice-over' },
    { id: 13, title: 'Sound Effects', name: 'sound-design' },
    { id: 128, title: 'Cover', name: 'cover' },
    { id: 16, title: 'Beats', name: 'beats' },
    { id: 19, title: 'Audiobook', name: 'audiobook' },
    { id: 97, title: 'Recording', name: 'recording' },
    { id: 100, title: 'Other', name: 'other' },
]

export const getCategoryByName = (name: string): TCategory | undefined =>
    CATEGORIES.find(category => category.name === name)

export const getCategoryById = (id: number): TCategory | undefined =>
    CATEGORIES.find(category => category.id === id)

const TRANSCRIBABLE_CATEGORY_NAMES: TCategoryName[] = ['podcast', 'voice-over']

const TRANSCRIBABLE_CATEGORY_IDS = CATEGORIES.filter(category =>
    TRANSCRIBABLE_CATEGORY_NAMES.includes(category.name),
).map(category => category.id)

export const isTranscribableCategory = (categoryId: number): boolean =>
    TRANSCRIBABLE_CATEGORY_IDS.includes(categoryId)
